import React from 'react';
import ReactDOM from 'react-dom';
// import './assets/styles/app.scss';
import App from './App';

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById('root'));
